import React from 'react';

const SigninPage = () => {
  return (
    <div>
      <h1>Signin page</h1>
    </div>
  );
};

export default SigninPage;
